import "./PageNewsStories.css";
import { Helmet } from "react-helmet-async";

const PageNewsStories = () => {
  return (
    <>
      <Helmet>
        <title>Student Loan News & Resources | BCGAP</title>
        <meta
          name="description"
          content="Curated news and resources about student loan debt relief, forgiveness programs, and repayment options."
        />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@graph": [
              {
                "@type": "Organization",
                "@id": "https://bcgap.org/#organization",
                name: "Bent Christy Graduate Assistance Program",
                alternateName: "BCGAP",
                url: "https://bcgap.org",
              },
              {
                "@type": "CollectionPage",
                name: "BCGAP News and Stories",
                description:
                  "A curated collection of news articles and resources related to student loan debt relief and repayment.",
                url: "https://bcgap.org/bent-christy-graduate-assistance-program-news-stories",
                publisher: {
                  "@id": "https://bcgap.org/#organization",
                },
                mainEntity: {
                  "@type": "ItemList",
                  itemListElement: [
                    {
                      "@type": "ListItem",
                      position: 1,
                      item: {
                        "@type": "Article",
                        headline: "Learn More About Student Loan Debt Relief",
                        url: "https://studentaid.gov",
                        publisher: {
                          "@type": "Organization",
                          name: "U.S. Department of Education",
                        },
                      },
                    },
                    {
                      "@type": "ListItem",
                      position: 2,
                      item: {
                        "@type": "Article",
                        headline:
                          "Student Loan Forgiveness (and Other Ways the Government Can Help You Repay Your Loans)",
                        url: "https://studentaid.gov/articles/student-loan-forgiveness/",
                        publisher: {
                          "@type": "Organization",
                          name: "U.S. Department of Education",
                        },
                      },
                    },
                  ],
                },
              },
            ],
          })}
        </script>
      </Helmet>

      <div className="news-page">
        <div className="news-section">
          <div className="news-card">
            <div className="image">
              <img
                style={{ objectPosition: "center 0" }}
                src="./images/news/news2.jpg"
                alt="bcgap-news-photo"
              />
            </div>
            <div className="content">
              <div className="title">
                Learn More About Student Loan Debt Relief
              </div>
              <div className="text">
                Federal student loans offer flexible repayment plans, loan
                consolidation, forgiveness programs, and more. We can help you
                manage repayment and answer any questions you have along the way
                ...
              </div>
              <div className="read-more-link">
                <a href="https://studentaid.gov">Read more</a>{" "}
              </div>
            </div>
          </div>
          {/*
        <div className="news-card">
          <div className="image">
            <img src="./images/news/news6-1.jpg" alt="BCGAP news" />
          </div>
          <div className="content">
            <div className="title">
              FACT SHEET: President Biden Cancels Student Debt for more than
              150,000 Student Loan Borrowers Ahead of Schedule
            </div>
            <div className="text">
              Today, President Biden announced the approval of $1.2 billion in
              student debt cancellation for almost 153,000 borrowers currently
              enrolled in the Saving on a Valuable Education (SAVE) repayment
              plan ...
            </div>
            <div className="read-more-link">
              <a href="https://www.whitehouse.gov/briefing-room/statements-releases/2024/02/21/fact-sheet-president-biden-cancels-student-debt-for-more-than-150000-student-loan-borrowers-ahead-of-schedule/">
                Read more
              </a>{" "}
            </div>
          </div>
        </div>
        */}
          <div className="news-card">
            <div className="image">
              <img src="./images/news/news4.webp" alt="BCGAP news" />
            </div>
            <div className="content">
              <div className="title">
                Student Loan Forgiveness (and Other Ways the Government Can Help
                You Repay Your Loans)
              </div>
              <div className="text">
                The Supreme Court blocked the one-time debt relief plan (you may
                also know this as the forgiveness of up to $20,000 for Pell
                Grant borrowers). But you may be able to get help repaying your
                loans, including full loan forgiveness, through other federal
                student loan ...
              </div>
              <div className="read-more-link">
                <a href="https://studentaid.gov/articles/student-loan-forgiveness/">
                  Read more
                </a>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PageNewsStories;
